
export const translationKeys = new Set ([
  "txt-loginmenupanel-title",
  "txt-requestformular-title",
  "txt-requestmenupanel-title",
  "txt-savings-account-data-changed",
  "txt-savings-account-data-information",
  "txt-savings-account-list-iban",
  "txt-savings-account-prolongation-successful",
  "txt-savings-account-selection",
  "txt-savings-accountDataInfo",
  "txt-savings-accountNumber",
  "txt-savings-accountdescription",
  "txt-savings-accountnumber",
  "txt-savings-accounttype",
  "txt-savings-advertisement",
  "txt-savings-advertising-approval",
  "txt-savings-amount",
  "txt-savings-amount-from",
  "txt-savings-amount-to",
  "txt-savings-amountavailable",
  "txt-savings-amountzero",
  "txt-savings-answer",
  "txt-savings-aria-amount",
  "txt-savings-aria-amountAvailable",
  "txt-savings-aria-interestRate",
  "txt-savings-answer-security-question",
  "txt-savings-austria",
  "txt-savings-av-amount",
  "txt-savings-availableamount",
  "txt-savings-back",
  "txt-savings-backpayment-success",
  "txt-savings-backpaymenttext",
  "txt-savings-bank-account",
  "txt-savings-bank-account-info",
  "txt-savings-bankaccount",
  "txt-savings-bankdetails",
  "txt-savings-booking-date",
  "txt-savings-booking-text",
  "txt-savings-cancel",
  "txt-savings-capitalgainstax",
  "txt-savings-captchaCheck",
  "txt-savings-change",
  "txt-savings-changePin",
  "txt-savings-changePin2",
  "txt-savings-checkfixaccountdata",
  "txt-savings-city",
  "txt-savings-clear-button",
  "txt-savings-close",
  "txt-savings-confirm",
  "txt-savings-confirmWithPin",
  "txt-savings-confirmWithPinAccountData",
  "txt-savings-confirmWithPinQuestion",
  "txt-savings-confirmation",
  "txt-savings-contact-data",
  "txt-savings-contractextension",
  "txt-savings-creationdate",
  "txt-savings-date",
  "txt-savings-date-from",
  "txt-savings-date-to",
  "txt-savings-dateOfBirth",
  "txt-savings-description",
  "txt-savings-designation",
  "txt-savings-differentamount",
  "txt-savings-download",
  "txt-savings-drivinglicense",
  "txt-savings-edit",
  "txt-savings-email",
  "txt-savings-empty",
  "txt-savings-enddate",
  "txt-savings-error-answerSecurityQuestion",
  "txt-savings-error-city",
  "txt-savings-error-dateOfBirth",
  "txt-savings-error-email",
  "txt-savings-error-firstName",
  "txt-savings-error-identification",
  "txt-savings-error-identificationNo",
  "txt-savings-error-industry",
  "txt-savings-error-infoDispAccepted",
  "txt-savings-error-issuedBy",
  "txt-savings-error-issuedOn",
  "txt-savings-error-lastName",
  "txt-savings-error-nationality",
  "txt-savings-error-netFinancialAsset",
  "txt-savings-error-netIncome",
  "txt-savings-error-occupation",
  "txt-savings-error-originOfFunds",
  "txt-savings-error-phoneNumber",
  "txt-savings-error-pinOne",
  "txt-savings-error-plannedInvVolume",
  "txt-savings-error-postalCode",
  "txt-savings-error-postcode",
  "txt-savings-error-principalResidence",
  "txt-savings-error-refBankAccName",
  "txt-savings-error-refHolderName",
  "txt-savings-error-refIban",
  "txt-savings-error-salutation",
  "txt-savings-error-securityQuestion",
  "txt-savings-error-sponsorFirstname",
  "txt-savings-error-sponsorLastname",
  "txt-savings-error-sponsorNumber",
  "txt-savings-error-street",
  "txt-savings-error-tradeOwnAccount",
  "txt-savings-error-validUntil",
  "txt-savings-euro",
  "txt-savings-excludinginterest",
  "txt-savings-export-excel",
  "txt-savings-extend",
  "txt-savings-filename",
  "txt-savings-filter",
  "txt-savings-firstname",
  "txt-savings-fixaccount",
  "txt-savings-fixaccount-created",
  "txt-savings-fixaccount-info",
  "txt-savings-fixamountsumnotreached",
  "txt-savings-followed-title",
  "txt-savings-general-info",
  "txt-savings-germany",
  "txt-savings-iban-info",
  "txt-savings-identification",
  "txt-savings-identificationno",
  "txt-savings-identitycard",
  "txt-savings-includinginterest",
  "txt-savings-income",
  "txt-savings-industry",
  "txt-savings-info-bank-account",
  "txt-savings-info-disp-accepted",
  "txt-savings-info-fin-asset",
  "txt-savings-info-iban",
  "txt-savings-info-legitimation",
  "txt-savings-info-sec-question",
  "txt-savings-interestamount",
  "txt-savings-interestpreview",
  "txt-savings-interestrate",
  "txt-savings-issuedby",
  "txt-savings-issuedon",
  "txt-savings-lastname",
  "txt-savings-legitimation",
  "txt-savings-legitimation-info",
  "txt-savings-lessthenavailable",
  "txt-savings-load-all",
  "txt-savings-login",
  "txt-savings-key-pad-hint",
  "txt-savings-make-friends",
  "txt-savings-mandatoryField",
  "txt-savings-maxamount",
  "txt-savings-nationality",
  "txt-savings-net-financial-asset",
  "txt-savings-net-financial-asset-info",
  "txt-savings-net-income",
  "txt-savings-new-customer",
  "txt-savings-newfixaccount",
  "txt-savings-next",
  "txt-savings-no-accounts",
  "txt-savings-no-documents",
  "txt-savings-no-open-orders",
  "txt-savings-no-sales",
  "txt-savings-occupation",
  "txt-savings-open-indizes",
  "txt-savings-origin-of-funds",
  "txt-savings-originalaccount",
  "txt-savings-owner-number",
  "txt-savings-passport",
  "txt-savings-paymentdate",
  "txt-savings-paymentdetails",
  "txt-savings-paymentfrom",
  "txt-savings-paymenttorefbankaccount",
  "txt-savings-personal-data",
  "txt-savings-personal-information",
  "txt-savings-phonenumber",
  "txt-savings-phonenumberHint",
  "txt-savings-pin",
  "txt-savings-pin-forgotten",
  "txt-savings-pin-one-changed",
  "txt-savings-pin-reset",
  "txt-savings-pin-two",
  "txt-savings-pin-two-changed",
  "txt-savings-pin-two-confirmation",
  "txt-savings-pin-two-confirmation-group",
  "txt-savings-pin-two-new",
  "txt-savings-pin-two-new-confirm",
  "txt-savings-pin-two-old",
  "txt-savings-pin2NewLength",
  "txt-savings-pin2OldLength",
  "txt-savings-pinNew",
  "txt-savings-pinNewCheck",
  "txt-savings-pinNewHint",
  "txt-savings-pinNewLength",
  "txt-savings-pinNewMatch",
  "txt-savings-pinNumber",
  "txt-savings-pinOld",
  "txt-savings-pinSuccess",
  "txt-savings-pinTwoCreateInfo",
  "txt-savings-pinTwoInfo",
  "txt-savings-planned-inv-volume",
  "txt-savings-postcode",
  "txt-savings-principal-residence",
  "txt-savings-print",
  "txt-savings-producttype",
  "txt-savings-question",
  "txt-savings-questions-text",
  "txt-savings-quetions",
  "txt-savings-ref-bank-acc-name",
  "txt-savings-ref-holder-name",
  "txt-savings-ref-holder-nameHint",
  "txt-savings-ref-iban",
  "txt-savings-reload",
  "txt-savings-request-control",
  "txt-savings-request-information",
  "txt-savings-request-success",
  "txt-savings-saldo",
  "txt-savings-sales-export",
  "txt-savings-salutation",
  "txt-savings-salutationmr",
  "txt-savings-salutationms",
  "txt-savings-security-question",
  "txt-savings-security-question-changed",
  "txt-savings-security-questions",
  "txt-savings-security-questions-info",
  "txt-savings-securityQuestionHint",
  "txt-savings-sponsor-data",
  "txt-savings-sponsor-info",
  "txt-savings-sponsornumber",
  "txt-savings-sponsornumberHint",
  "txt-savings-status",
  "txt-savings-street",
  "txt-savings-text",
  "txt-savings-text-ads",
  "txt-savings-text-disp-accepted",
  "txt-savings-text-legal-notice",
  "txt-savings-title",
  "txt-savings-token-invalid",
  "txt-savings-trade-own-account",
  "txt-savings-type",
  "txt-savings-typeofextension",
  "txt-savings-us",
  "txt-savings-usage",
  "txt-savings-user-blocked-error",
  "txt-savings-valid-until",
  "txt-savings-valuedate",
]);
